import { AnglerClass, AnglerId, ITournamentEODRedis } from '../../types';

export interface ITankAnglerData {
  '@': ITankEntry;
  STATUS: ITankStatus;
  ANGLERS: ITankAnglerVariants;
}

export interface ITankEntry {
  ID: string;
  DAY: string;
  CUTDAY: string;
  CUTNUMBER: string;
  HASTEAM: string;
}

export interface ITankStatus {
  '@': ITankStatusType;
}

export interface ITankStatusType {
  TYPE: string;
}

export interface ITankAnglerVariants {
  ANGLER: ITankAngler[] | ITankAngler;
}

export interface ITankAngler {
  ID: AnglerId;
  CLASS: AnglerClass;
  NAME_FIRST: string;
  NAME_MIDDLE: object;
  NAME_LAST: string;
  NAME_FONTNAME: string;
  BUMPSTAMP: string;
}

export type MaybeITankAnglerData = ITournamentEODRedis | ITankAnglerData;
// Helper guard function to determine between active and EOD tournament
export function isEOD(
  tournament: MaybeITankAnglerData
): tournament is ITournamentEODRedis {
  return (tournament as ITournamentEODRedis).REDIS_EOD_VALUE !== undefined;
}
